export const PLANS_PAGE_REFERRER = 'plans'
